(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desky-cart-main-slider"] && !Shopify.designMode) return;
  try {
    

if(!window.location.href.includes("/products/")){
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Get popups by their specific IDs
    const returnsPopup = document.querySelector('#returns-popup');
    const warrantyPopup = document.querySelector('#warranty-popup');

    function showPopup(popupEl) {
      if (!popupEl) return;
      popupEl.classList.remove('dy:hidden');
      document.body.style.overflow = 'hidden';
    }

    function hidePopup(popupEl) {
      if (!popupEl) return;
      popupEl.classList.add('dy:hidden');
      document.body.style.overflow = 'auto';
    }

    function loadReturnsPopup() {
      const existing = document.getElementById('returns-popup');
      if (existing) return Promise.resolve(existing);
      if (window.__returnsPopupLoading) return window.__returnsPopupLoading;

      const sectionUrl = `${window.location.pathname}?section_id=returns-journey`;
      window.__returnsPopupLoading = fetch(sectionUrl)
        .then((res) => res.text())
        .then((html) => {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const popupEl = temp.querySelector('#returns-popup');
          if (!popupEl) return null;
          document.body.appendChild(popupEl);
          const scripts = temp.querySelectorAll('script');
          scripts.forEach((script) => {
            const s = document.createElement('script');
            if (script.src) {
              s.src = script.src;
            } else {
              s.textContent = script.textContent;
            }
            document.body.appendChild(s);
          });
          if (typeof window.returnsInit === 'function') {
            window.returnsInit();
          }
          return popupEl;
        })
        .catch((err) => {
          console.error('Failed to load returns popup:', err);
          return null;
        })
        .finally(() => {
          window.__returnsPopupLoading = null;
        });

      return window.__returnsPopupLoading;
    }

    window.loadReturnsPopup = loadReturnsPopup;

    function loadWarrantyPopup() {
      const existing = document.getElementById('warranty-popup');
      if (existing) return Promise.resolve(existing);
      if (window.__warrantyPopupLoading) return window.__warrantyPopupLoading;

      const sectionUrl = `${window.location.pathname}?section_id=warranty-journey`;
      window.__warrantyPopupLoading = fetch(sectionUrl)
        .then((res) => res.text())
        .then((html) => {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const popupEl = temp.querySelector('#warranty-popup');
          if (!popupEl) return null;
          document.body.appendChild(popupEl);
          const scripts = temp.querySelectorAll('script');
          scripts.forEach((script) => {
            const s = document.createElement('script');
            if (script.src) {
              s.src = script.src;
            } else {
              s.textContent = script.textContent;
            }
            document.body.appendChild(s);
          });
          if (typeof window.warrantyInit === 'function') {
            window.warrantyInit();
          }
          return popupEl;
        })
        .catch((err) => {
          console.error('Failed to load warranty popup:', err);
          return null;
        })
        .finally(() => {
          window.__warrantyPopupLoading = null;
        });

      return window.__warrantyPopupLoading;
    }

    window.loadWarrantyPopup = loadWarrantyPopup;

    function loadGeneralQueryPopup() {
      const existing = document.getElementById('general-query-popup');
      if (existing) return Promise.resolve(existing);
      if (window.__generalQueryPopupLoading) return window.__generalQueryPopupLoading;

      const sectionUrl = `${window.location.pathname}?section_id=general-query-journey`;
      window.__generalQueryPopupLoading = fetch(sectionUrl)
        .then((res) => res.text())
        .then((html) => {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const popupEl = temp.querySelector('#general-query-popup');
          if (!popupEl) return null;
          document.body.appendChild(popupEl);
          const scripts = temp.querySelectorAll('script');
          scripts.forEach((script) => {
            const s = document.createElement('script');
            if (script.src) {
              s.src = script.src;
            } else {
              s.textContent = script.textContent;
            }
            document.body.appendChild(s);
          });
          if (typeof window.gqInit === 'function') {
            window.gqInit();
          }
          return popupEl;
        })
        .catch((err) => {
          console.error('Failed to load general query popup:', err);
          return null;
        })
        .finally(() => {
          window.__generalQueryPopupLoading = null;
        });

      return window.__generalQueryPopupLoading;
    }

    window.loadGeneralQueryPopup = loadGeneralQueryPopup;

    function loadShippingPopup() {
      const existing = document.getElementById('shipping-popup');
      if (existing) return Promise.resolve(existing);
      if (window.__shippingPopupLoading) return window.__shippingPopupLoading;

      const sectionUrl = `${window.location.pathname}?section_id=shipping-journey`;
      window.__shippingPopupLoading = fetch(sectionUrl)
        .then((res) => res.text())
        .then((html) => {
          const temp = document.createElement('div');
          temp.innerHTML = html;
          const popupEl = temp.querySelector('#shipping-popup');
          if (!popupEl) return null;
          document.body.appendChild(popupEl);
          const scripts = temp.querySelectorAll('script');
          scripts.forEach((script) => {
            const s = document.createElement('script');
            if (script.src) {
              s.src = script.src;
            } else {
              s.textContent = script.textContent;
            }
            document.body.appendChild(s);
          });
          if (typeof window.shipInit === 'function') {
            window.shipInit();
          }
          return popupEl;
        })
        .catch((err) => {
          console.error('Failed to load shipping popup:', err);
          return null;
        })
        .finally(() => {
          window.__shippingPopupLoading = null;
        });

      return window.__shippingPopupLoading;
    }

    window.loadShippingPopup = loadShippingPopup;

    // Returns popup functionality
    const returnsButton = document.getElementById('footer-open-returns');
    if (returnsButton) {
      returnsButton.addEventListener('click', function (e) {
        e.preventDefault();
        loadReturnsPopup().then((popupEl) => {
          showPopup(popupEl);
          if (typeof window.returnsShowStep === 'function') {
            window.returnsShowStep(1);
          }
        });
      });
    }

    // Warranty popup functionality
    const warrantyButton = document.getElementById('footer-open-warranty');
    if (warrantyButton) {
      warrantyButton.addEventListener('click', function (e) {
        e.preventDefault();
        loadWarrantyPopup().then((popupEl) => {
          showPopup(popupEl);
          if (typeof window.warrantyShowStep === 'function') {
            window.warrantyShowStep(1);
          }
        });
      });
    }

    // Shipping popup functionality
    const shippingButton = document.getElementById('footer-open-shipping');
    if (shippingButton) {
      shippingButton.addEventListener('click', function (e) {
        e.preventDefault();
        loadShippingPopup().then((popupEl) => {
          showPopup(popupEl);
          if (typeof window.shipShowStep === 'function') {
            window.shipShowStep(1);
          }
        });
      });
    }

    // General enquiry popup functionality
    const generalEnquiryButton = document.getElementById('show-form-wrapper');
    if (generalEnquiryButton) {
      generalEnquiryButton.addEventListener('click', function (e) {
        e.preventDefault();
        loadGeneralQueryPopup().then((popupEl) => {
          showPopup(popupEl);
          if (typeof window.gqShowStep === 'function') {
            window.gqShowStep(1);
          }
        });
      });
    }

    // Close popup functionality (delegated for dynamic popups)
    document.addEventListener('click', function (e) {
      const closeButton = e.target.closest('#closePopup');
      if (closeButton) {
        const popup = closeButton.closest('#returns-popup, #warranty-popup');
        hidePopup(popup);
        return;
      }

      const overlayPopup = e.target.closest('#returns-popup, #warranty-popup');
      if (overlayPopup && e.target === overlayPopup) {
        hidePopup(overlayPopup);
      }
    });

    // Close popup with Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const visiblePopup = document.querySelector(
          '#returns-popup:not(.dy\\:hidden), #warranty-popup:not(.dy\\:hidden)'
        );
        if (visiblePopup) {
          visiblePopup.classList.add('dy:hidden');
          document.body.style.overflow = 'auto'; // Restore scrolling
        }
      }
    });

    // Check URL parameters and open popups if needed
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('returns-popup') === 'true') {
      loadReturnsPopup().then((popupEl) => {
        showPopup(popupEl);
        if (typeof window.returnsShowStep === 'function') {
          window.returnsShowStep(1);
        }
      });
    }
    if (urlParams.get('warranty-popup') === 'true') {
      loadWarrantyPopup().then((popupEl) => {
        showPopup(popupEl);
        if (typeof window.warrantyShowStep === 'function') {
          window.warrantyShowStep(1);
        }
      });
    }
    if (urlParams.get('general-query-popup') === 'true') {
      loadGeneralQueryPopup().then((popupEl) => {
        showPopup(popupEl);
        if (typeof window.gqShowStep === 'function') {
          window.gqShowStep(1);
        }
      });
    }
    if (urlParams.get('shipping-popup') === 'true') {
      loadShippingPopup().then((popupEl) => {
        showPopup(popupEl);
        if (typeof window.shipShowStep === 'function') {
          window.shipShowStep(1);
        }
      });
    }
  });

  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-v2"]) return;
  try {
    
                            //ModalDialog 
  class ProductModal extends HTMLElement  {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
                            //ModalDialog 
  class ProductModal extends HTMLElement  {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
